import { Divider, Form, Radio, Switch } from 'antd';
import classnames from 'classnames';

import { SwitchableInput } from 'app/components/commons/SwitchableInput/SwitchableInput';
import type { DayOfWeek } from 'app/typings/core/common/enum/dayOfWeek';

import styles from '../RoomDiscount.module.scss';
import type { DefaultDiscountMode } from '../hooks/useRoomDiscountLogic';

import { ConstantDiscountRow } from './ConstantDiscountRow';
import { RoomDiscountDaysTable } from './RoomDiscountDaysTable';

type DefaultDiscountSectionProps = {
  currencyFormatter: (value: number) => string;
  formRoomPrice?: number | null;
  discountMode: DefaultDiscountMode;
  defaultNightRoomDiscount?: number | null;
  defaultNightRoomDiscountDays?: Partial<Record<DayOfWeek, number>> | null;
  getDayBasePrice: (day: DayOfWeek) => number | null | undefined;
  onDiscountModeChange: (mode: DefaultDiscountMode) => void;
  isDiscountEnabled: boolean;
  onDiscountToggle: (value: boolean) => void;
};

export const DefaultDiscountSection = ({
  currencyFormatter,
  formRoomPrice,
  discountMode,
  defaultNightRoomDiscount,
  defaultNightRoomDiscountDays,
  getDayBasePrice,
  onDiscountModeChange,
  isDiscountEnabled,
  onDiscountToggle,
}: DefaultDiscountSectionProps) => (
  <div className={styles.wrapper}>
    <div className={styles.discountHeader}>
      <p className={styles.discountTitle}>DEFAULT DISCOUNT</p>
    </div>
    <div
      className={classnames(
        styles.switchableWrapper,
        styles.discountModeWrapper
      )}
    >
      <Form.Item name="isDefaultDiscountEnabled" valuePropName="checked" hidden>
        <Switch />
      </Form.Item>
      <SwitchableInput
        title={
          <div className={styles.discountTitleWrapper}>
            <p className={styles.switchTitle}>Default discount</p>
          </div>
        }
        value={isDiscountEnabled}
        onChange={onDiscountToggle}
        childNode={
          <>
            <Divider className={styles.lastMinuteDivider} />
            <Form.Item noStyle name="defaultDiscountMode">
              <Radio.Group
                className={styles.discountModeRadios}
                onChange={(e) =>
                  onDiscountModeChange(e.target.value as DefaultDiscountMode)
                }
                disabled={!isDiscountEnabled}
              >
                <Radio value="CONSTANT">Same every day</Radio>
                <Radio value="DAILY">Depends on the day</Radio>
              </Radio.Group>
            </Form.Item>
            <div style={{ padding: '16px 0' }} />
            {discountMode === 'DAILY' ? (
              <div className={styles.daysWrapper}>
                <span>
                  Apply a discount to all rooms within packages for each day of
                  the week:
                </span>
                <RoomDiscountDaysTable
                  currencyFormatter={currencyFormatter}
                  defaultNightRoomDiscountDays={defaultNightRoomDiscountDays}
                  getDayBasePrice={getDayBasePrice}
                  isEnabled={isDiscountEnabled}
                />
              </div>
            ) : (
              <ConstantDiscountRow
                currencyFormatter={currencyFormatter}
                formRoomPrice={formRoomPrice}
                defaultNightRoomDiscount={defaultNightRoomDiscount}
                isEnabled={isDiscountEnabled}
              />
            )}
          </>
        }
        noBorder
        noPadding
      />
    </div>
  </div>
);
